import React, { useEffect, useState } from 'react';
import { Box, Button } from '@material-ui/core';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import GenericApprovalScreen from '../common/GenericApprovalScreen';
import { EDITORIAL_STORY_TABLE_COLUMNS, STORY_TABLE_COLUMNS } from './columns';
import { useDispatch, useSelector } from 'react-redux';
import useToast from '../../../hooks/useToast';
import {
  getApprovalListAsync,
  getEditorialStoryAsync,
} from '../ApprovalStore/approvalSlice';
import { Link } from 'react-router-dom/cjs/react-router-dom';

function StoryApprovalScreen() {
  const dispatch = useDispatch();
  const { ErrorToast } = useToast();
  const [page, setPage] = useState(1);
  const [userIdStory, setUserIdStory] = useState('');
  const [status, setStatus] = useState('pending');
  const [selectStory, setSelectStory] = useState('normal');
  const PER_PAGE_FOR_STORY = 10;

  const { approvalList, approvalCount, allEditorialStory } = useSelector(
    ({ approvalReducer }) => {
      return {
        approvalList: approvalReducer.commonApprovalList,
        approvalCount: approvalReducer.commonApprovalCount,
        allEditorialStory: approvalReducer.editorialStory,
      };
    }
  );

  const STATUS_OPTION = [
    { label: 'Pending', value: 'pending' },
    { label: 'Approve', value: 'approved' },
    { label: 'Rejected', value: 'rejected' },
  ];

  const STORY_OPTION = [
    { label: 'Normal Story', value: 'normal' },
    { label: 'Editorial Story', value: 'editorial' },
  ];

  useEffect(() => {
    dispatch(
      getApprovalListAsync({
        params: {
          entityType: 'article',
          approvalType: 'article-status',
          limit: 10,
          page: 1,
          statuses: ['pending'],
        },
        type: 'common',
      })
    );
  }, []);

  const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'article',
            approvalType: 'article-status',
            limit: 10,
            page: val,
            statuses: ['pending'],
          },
          type: 'common',
        })
      )
        .unwrap()
        .then((res) => {
          if (res && res.status > 299) {
            ErrorToast(res.message);
          }
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
  };

  const handlePageChange1 = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(getEditorialStoryAsync({ params: { limit: 10, page: val } }))
        .unwrap()
        .then((res) => {
          if (res && res.status > 299) {
            ErrorToast(res.message);
          }
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
  };

  const handleStatus = (e) => {
    setStatus(e.target.value);

    if (userIdStory !== '') {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'article',
            approvalType: 'article-status',
            limit: PER_PAGE_FOR_STORY,
            page: 1,
            statuses: [e.target.value],
            secondaryFilter: { userId: userIdStory },
          },
          type: 'common',
        })
      );
    } else {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'article',
            approvalType: 'article-status',
            limit: PER_PAGE_FOR_STORY,
            page: 1,
            statuses: [e.target.value],
          },
          type: 'common',
        })
      );
    }
  };

  const handleStory = (value) => {
    setSelectStory(value);
    dispatch(
      getEditorialStoryAsync({ params: { limit: PER_PAGE_FOR_STORY, page: 1 } })
    );
  };

  const handleSearchStory = () => {
    if (userIdStory !== '') {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'article',
            approvalType: 'article-status',
            limit: 10,
            page: 1,
            statuses: [status],
            secondaryFilter: { userId: userIdStory },
          },
          type: 'common',
        })
      );
    } else {
      dispatch(
        getApprovalListAsync({
          params: {
            entityType: 'article',
            approvalType: 'article-status',
            limit: 10,
            page: 1,
            statuses: [status],
          },
          type: 'common',
        })
      );
    }
  };

  const Filters = () => {
    return (
      <Box display="flex">
        <Box mr={4} width={350}>
          <BuzzInput
            fullWidth={true}
            placeholder={'Search story by user id'}
            search
            value={userIdStory}
            onChange={(e) => setUserIdStory(e.target.value)}
            onSubmitEditing={handleSearchStory}
            size="small"
            label="Seach story"
          />
        </Box>
        <Box>
          <BuzzSelect
            width={180}
            name="status"
            size={'small'}
            placeholder={'Select status'}
            value={status}
            onChange={handleStatus}
            label="Select status"
            valueKey="value"
            labelKey="label"
            options={STATUS_OPTION}
          />
        </Box>
        <Box ml={'auto'}>
          <BuzzSelect
            width={180}
            name="story"
            size={'small'}
            placeholder={'Select Story'}
            value={selectStory}
            onChange={(e) => handleStory(e.target.value)}
            label="Select Story"
            valueKey="value"
            labelKey="label"
            options={STORY_OPTION}
          />
        </Box>
      </Box>
    );
  };

  const FiltersEditorial = () => {
    return (
      <Box display="flex">
        <Box>
          <Link to="/approval-management/create-story">
            <Button variant="contained" color="primary">
              Create Editorial Story
            </Button>
          </Link>
        </Box>
        <Box ml={'auto'} mt={-1}>
          <BuzzSelect
            width={180}
            name="story"
            size={'small'}
            placeholder={'Select Story'}
            value={selectStory}
            onChange={(e) => setSelectStory(e.target.value)}
            // label="Select Story"
            valueKey="value"
            labelKey="label"
            options={STORY_OPTION}
          />
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      {selectStory === 'normal' ? (
        <GenericApprovalScreen
          title="Story Approval"
          FilterComponents={() => <Filters />}
          tableData={approvalList}
          tableDataCount={approvalCount}
          tableColumn={STORY_TABLE_COLUMNS}
          handlePageChange={handlePageChange}
          page={page}
          perPage={PER_PAGE_FOR_STORY}
        />
      ) : (
        <GenericApprovalScreen
          title="Editorial Story"
          FilterComponents={() => <FiltersEditorial />}
          tableData={allEditorialStory && allEditorialStory.data}
          tableDataCount={allEditorialStory && allEditorialStory.count}
          tableColumn={EDITORIAL_STORY_TABLE_COLUMNS}
          handlePageChange={handlePageChange1}
          page={page}
          perPage={PER_PAGE_FOR_STORY}
        />
      )}
    </Box>
  );
}

export default StoryApprovalScreen;
